import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  MEDIUM_DEVICE_MQ,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const cardItemClassName = css({
  background: Colors.White,
  borderTop: `1px solid ${Colors.LightGray}`,
  cursor: 'pointer',
  padding: `${Spacing.LG}px 0`,
  '&:first-child': {
    border: 'none',
    paddingTop: 0,
  },
  [SMALL_DEVICE_MQ]: {
    padding: Spacing.LG,
    transition: '0.2s',
    '&:first-child': {
      borderRadius: '12px 12px 0 0',
      paddingTop: Spacing.LG,
    },
    '&:last-child': {
      borderRadius: '0 0 12px 12px',
    },
    '&:hover': {
      background: '#F8F8F8',
    },
  },
  [MEDIUM_DEVICE_MQ]: {
    padding: `${Spacing.LG}px ${Spacing.XL}px`,
  },
});

export const cardItemHeaderClassName = css({
  alignItems: 'center',
  display: 'flex',
});

export const subheadingClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.SEMI_BOLD,
  [SMALL_DEVICE_MQ]: {
    fontWeight: FontWeight.MEDIUM,
  },
});

export const cardItemBodyClassName = css({
  marginTop: Spacing.MD,
});

export const titleClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.BOLD,
  [SMALL_DEVICE_MQ]: {
    fontWeight: FontWeight.SEMI_BOLD,
  },
});

export const cardItemFooterClassName = css({
  alignItems: 'center',
  display: 'flex',
  marginTop: 18,
  [SMALL_DEVICE_MQ]: {
    marginTop: Spacing.MD,
  },
});

export const cardItemTagClassName = css({
  alignItems: 'center',
  display: 'flex',
  marginRight: Spacing.LG,
  '&:last-child': {
    marginLeft: 'auto',
  },
});

export const iconClassName = css({
  color: Colors.Secondary,
  height: 14,
  width: 14,
});

export const statusIconClassName = css({
  marginLeft: Spacing.XS,
  height: 9,
  width: 9,
});

export const labelClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
  marginLeft: Spacing.XS,
});

export const successClassName = css({
  color: Colors.Green,
});

export const errorClassName = css({
  color: Colors.Red,
});

export const infoClassName = css({
  color: Colors.Brand,
});
